// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3tiYV","modalForm":"UpgradeEpcsModal_modalForm__OUPjq","modalFooter":"UpgradeEpcsModal_modalFooter__3g0Vx"};